module.exports = __webpack_public_path__ + "img/ModularWallV10.25da75c8.jpg";